import EmptyRouterView from '@/components/common/EmptyRouterView.vue'
import JobsForProof from '@/views/JobsForProof/Index'

export default [
    {
        path: '/jobsForProof',
        component: EmptyRouterView,
        meta: {
            title: 'Zlecenia na proof',
            menuRendered: true,
            menuTitle: 'Zlecenia na proof',
            requiresAuth: true,
            permission: 'proof_job',
            icon: 'mdi-cloud-check',
        },
        children: [
            {
                path: '',
                name: 'jobsForProof',
                component: JobsForProof,
                meta: {
                    title: 'Zlecenia na proof',
                    requiresAuth: true,
                    permission: 'proof_job',
                },
            },
        ],
    }
]
